import React, {useEffect, useRef, useState} from 'react';
import "v4/components/utils/SearchContextSearchbar/SearchContextSearchbar.scss";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {useSearchContext} from "v4/contexts/SearchContext/SearchContext";
import PolButton from "v4/components/ui/PolButton/PolButton";
import {PolIcon} from "components/PolIcon/policon";
import ReactTooltip from "react-tooltip";

export default function SearchContextSearchbar() {
    const {t} = usePolTranslation();
    const {tab, searchbar, setSearchbar} = useSearchContext();
    const [searchbarInput, setSearchbarInput] = useState('');
    const inputRef = useRef(null);
    const tooltipTimer = useRef(null);

    useEffect(() => {
        if (searchbar === searchbarInput) return

        setSearchbarInput(searchbar);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchbar]);

    useEffect(() => {
        return () => {
            // Clear the tooltip timer when the component unmounts
            if (tooltipTimer.current) clearTimeout(tooltipTimer.current);
        };
    }, []);

    const onChange = ({currentTarget: {value}}) => {
        if (tab) {
            // try catch to avoid error when currentSavedSearch is not a valid JSON
            try {
                const {searchbar: savedSearchbar} = JSON.parse(tab.searchContent);
                if (savedSearchbar === value) return;
            } catch (e) {
                console.error(e);
            }
        }

        setSearchbarInput(value);

        // Reset the tooltip timer when the input value changes
        if (tooltipTimer.current) clearTimeout(tooltipTimer.current);

        // If the input value is the same as the searchbar, hide the tooltip (it means the user already has the page)
        if (searchbar === value) {
            inputRef.current.dispatchEvent(new Event('hideTooltip'));
        } else {
            // Show the tooltip after 2 seconds of inactivity
            tooltipTimer.current = setTimeout(() => {
                inputRef.current.dispatchEvent(new Event('showTooltip'));
            }, 2000);
        }
    };

    const submitSearch = () => {
        // Clear the tooltip timer
        if (tooltipTimer.current) clearTimeout(tooltipTimer.current);
        if (inputRef.current) inputRef.current.dispatchEvent(new Event('hideTooltip'));

        setSearchbar(searchbarInput);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            submitSearch();
        }
    }

    return (
        <div className="listing-searchbar">
            <input type="search"
                   className="datatable__search__input"
                   placeholder={t('votre_recherche')}
                   value={searchbarInput}
                   onChange={onChange}
                   onKeyDown={handleKeyDown}
                   data-tip={t('searchbar_tip')}
                   data-for="searchbarTooltip"
                   ref={inputRef}
            />
            <PolButton onClick={submitSearch}>
                <PolIcon icon="search"/>
            </PolButton>

            <ReactTooltip effect="solid" id="searchbarTooltip" event="showTooltip" eventOff="hideTooltip"/>
        </div>
    )
}
